import { render, staticRenderFns } from "./LeadsPNTransferList.vue?vue&type=template&id=facd482a&scoped=true"
import script from "./LeadsPNTransferList.vue?vue&type=script&lang=js"
export * from "./LeadsPNTransferList.vue?vue&type=script&lang=js"
import style0 from "./LeadsPNTransferList.vue?vue&type=style&index=0&id=facd482a&prod&lang=scss&scoped=true"
import style1 from "./LeadsPNTransferList.vue?vue&type=style&index=1&id=facd482a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "facd482a",
  null
  
)

export default component.exports